// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h29mOy {
  margin: 0;
  height: 100vh;
  padding: 0 !important;
  position: fixed !important;
  right: 0;
  top: 0;
}

.waUKdI {
  margin: 0 auto;
  max-width: var(--grid-breakpoint-l);
  height: 100vh;
  transform: none !important;
}

.XxNMhn {
  margin: 0;
  margin-left: auto;
  max-width: 400px;
  height: 100vh;
  border-radius: 0;
  border: none;
  background-color: var(--surface-neutral-white, #ffffff);
  display: flex;
  flex-direction: column;
}

._6jUIG {
  background-color: var(--neutral-dark-opacity-50) !important;
}

.VdJF70 {
  padding: var(--spacing-3) var(--spacing-2) 0;
  border: none;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  flex-shrink: 0;
}

.Hsg48b {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.o9dLJy {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
  flex: 1;
}

.BMpn7C {
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
  min-height: 0;
  flex: 1;
}

.jOADcb {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-2);
  padding: var(--spacing-3);
  border-top: none;
  background-color: var(--surface-neutral-white, #ffffff);
  flex-shrink: 0;
}

.N8Kbgo {
  width: 100%;
}

.aINCbY {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  overflow-y: auto;
  min-height: 0;
}

.W_FsV0 {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark, #1f1f1f);
}

.PhrHEl {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.PhrHEl .T130Sp,
.PhrHEl .T130Sp:hover,
.PhrHEl .T130Sp[data-selected='true'],
.PhrHEl .T130Sp[data-selected='true']:hover {
  background-color: var(--surface-neutral-subtle, #f2f2f2);
}

.PhrHEl .Zjjurk {
  opacity: 0.5;
  cursor: default;
}

.OSNJ3D {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark, #1f1f1f);
}

.SzuWIp {
  margin-top: var(--spacing-0-5);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark, #1f1f1f);
}

.ocf799 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
}

.yTOqfg {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark, #1f1f1f);
}

.i7_vWQ {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-2);
}

.Jh81xW {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  padding: 0 var(--spacing-1-5);
  background-color: var(--surface-neutral-pale, #fafafa);
  border: 1px solid var(--stroke-neutral-silver, #cccccc);
  border-radius: var(--radius-s, 4px);
  height: 40px;
  flex-shrink: 0;
}

.JtmpC8 {
  flex-shrink: 0;
}

.VANCxn {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark, #1f1f1f);
  min-width: 0;
}

.vVlrle {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.NPSeKc {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  flex-shrink: 0;
}

.mYKuGV {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark, #1f1f1f);
}

.WMf1az {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
  overflow-y: auto;
  min-height: 0;
}

.z1ZD7U {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  padding: var(--spacing-2);
  border-radius: var(--radius-s, 4px);
  background-color: var(--surface-neutral-pale, #fafafa);
}

.ZUiQR0 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
  min-width: 0;
}

.zTcsQJ {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark, #1f1f1f);
}

.YYy_S5 {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-stronger, #666666);
}

.ad4M06 {
  width: 1px;
  height: 12px;
  background-color: var(--surface-neutral-light, #e6e6e6);
}

.zz_BZc {
  margin: 0;
  padding: var(--spacing-3) 0;
  text-align: center;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  line-height: var(--line-height-160);
  color: var(--text-neutral-stronger, #666666);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/EmissorRechargeReportDrawer/EmissorRechargeReportDrawer.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,uDAAuD;EACvD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,wCAAwC;EACxC,SAAS;EACT,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,OAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,uDAAuD;EACvD,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;;;EAIE,wDAAwD;AAC1D;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,sDAAsD;EACtD,uDAAuD;EACvD,mCAAmC;EACnC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,mCAAmC;EACnC,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uDAAuD;AACzD;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,oCAAoC;EACpC,8BAA8B;EAC9B,mCAAmC;EACnC,4CAA4C;AAC9C","sourcesContent":[".modal {\n  margin: 0;\n  height: 100vh;\n  padding: 0 !important;\n  position: fixed !important;\n  right: 0;\n  top: 0;\n}\n\n.modalDialog {\n  margin: 0 auto;\n  max-width: var(--grid-breakpoint-l);\n  height: 100vh;\n  transform: none !important;\n}\n\n.modalContent {\n  margin: 0;\n  margin-left: auto;\n  max-width: 400px;\n  height: 100vh;\n  border-radius: 0;\n  border: none;\n  background-color: var(--surface-neutral-white, #ffffff);\n  display: flex;\n  flex-direction: column;\n}\n\n.backdrop {\n  background-color: var(--neutral-dark-opacity-50) !important;\n}\n\n.modalHeader {\n  padding: var(--spacing-3) var(--spacing-2) 0;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  flex-shrink: 0;\n}\n\n.backButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n}\n\n.modalTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n  flex: 1;\n}\n\n.modalBody {\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  overflow: hidden;\n  min-height: 0;\n  flex: 1;\n}\n\n.modalFooter {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-2);\n  padding: var(--spacing-3);\n  border-top: none;\n  background-color: var(--surface-neutral-white, #ffffff);\n  flex-shrink: 0;\n}\n\n.action {\n  width: 100%;\n}\n\n.stepContent {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3);\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.stepHint {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.modalityList {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n}\n\n.modalityList .modalityCard,\n.modalityList .modalityCard:hover,\n.modalityList .modalityCard[data-selected='true'],\n.modalityList .modalityCard[data-selected='true']:hover {\n  background-color: var(--surface-neutral-subtle, #f2f2f2);\n}\n\n.modalityList .modalityCardDisabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.modalityTitle {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.modalityDescription {\n  margin-top: var(--spacing-0-5);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.periodSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n}\n\n.sectionTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.periodPresets {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--spacing-2);\n}\n\n.searchField {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  padding: 0 var(--spacing-1-5);\n  background-color: var(--surface-neutral-pale, #fafafa);\n  border: 1px solid var(--stroke-neutral-silver, #cccccc);\n  border-radius: var(--radius-s, 4px);\n  height: 40px;\n  flex-shrink: 0;\n}\n\n.searchIcon {\n  flex-shrink: 0;\n}\n\n.searchInput {\n  flex: 1;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark, #1f1f1f);\n  min-width: 0;\n}\n\n.searchClear {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.selectAllRow {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n  flex-shrink: 0;\n}\n\n.selectAllLabel {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.beneficiaryList {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.beneficiaryCard {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n  padding: var(--spacing-2);\n  border-radius: var(--radius-s, 4px);\n  background-color: var(--surface-neutral-pale, #fafafa);\n}\n\n.beneficiaryTexts {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n  min-width: 0;\n}\n\n.beneficiaryName {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.beneficiaryDetails {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-stronger, #666666);\n}\n\n.beneficiaryDivider {\n  width: 1px;\n  height: 12px;\n  background-color: var(--surface-neutral-light, #e6e6e6);\n}\n\n.listFeedback {\n  margin: 0;\n  padding: var(--spacing-3) 0;\n  text-align: center;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-stronger, #666666);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `h29mOy`,
	"modalDialog": `waUKdI`,
	"modalContent": `XxNMhn`,
	"backdrop": `_6jUIG`,
	"modalHeader": `VdJF70`,
	"backButton": `Hsg48b`,
	"modalTitle": `o9dLJy`,
	"modalBody": `BMpn7C`,
	"modalFooter": `jOADcb`,
	"action": `N8Kbgo`,
	"stepContent": `aINCbY`,
	"stepHint": `W_FsV0`,
	"modalityList": `PhrHEl`,
	"modalityCard": `T130Sp`,
	"modalityCardDisabled": `Zjjurk`,
	"modalityTitle": `OSNJ3D`,
	"modalityDescription": `SzuWIp`,
	"periodSection": `ocf799`,
	"sectionTitle": `yTOqfg`,
	"periodPresets": `i7_vWQ`,
	"searchField": `Jh81xW`,
	"searchIcon": `JtmpC8`,
	"searchInput": `VANCxn`,
	"searchClear": `vVlrle`,
	"selectAllRow": `NPSeKc`,
	"selectAllLabel": `mYKuGV`,
	"beneficiaryList": `WMf1az`,
	"beneficiaryCard": `z1ZD7U`,
	"beneficiaryTexts": `ZUiQR0`,
	"beneficiaryName": `zTcsQJ`,
	"beneficiaryDetails": `YYy_S5`,
	"beneficiaryDivider": `ad4M06`,
	"listFeedback": `zz_BZc`
};
module.exports = ___CSS_LOADER_EXPORT___;
